// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"97ad8c2c","787":"5f8c7687","885":"c142ac99","921":"49a6acbc"}[chunkId] + ".chunk.js";
};